import React, { useState, useEffect } from "react";
import "../Css/Userlog.css";

const LogTable = () => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const apiUrl = "https://api.gkaglobal.org/restgka/log.php";

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        console.log("Data received:", data);
        setLogs(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        alert("Error fetching data");
      });
  }, []);

  return (
    <div className="dashboard">
      {/* Sidebar */}

      {/* Main Content */}
      <main className="main-content">
        <div className="header">
          <h1>Log Data Table</h1>
        </div>

        <div className="table-container1">
          <table id="logTable1">
            <thead>
              <tr>
                <th>User Name</th>
                <th>Log Date</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, index) => (
                <tr key={index}>
                  <td>{log.UserName}</td>
                  <td>{log.log_dt}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="2">Total Records: {logs.length}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </main>
    </div>
  );
};

export default LogTable;
